"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var isGraduated = function isGraduated(month, year) {
  var dateGraduation = new Date(year, month);
  var toDay = new Date();
  if (dateGraduation.getTime() < toDay.getTime()) return 'Graduated';
  return 'Graduating';
};
var _default = isGraduated;
exports.default = _default;